import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getProtectedResource } from "../../services/apiRequest.service";
import { TextResponse } from "../../models/responseData";
import { cleanString } from "../../utils/formatString";
import { determineResponseTypeTextResponse } from "../../utils/determineResponseType";
import { formatRouteText } from "../../navigation/utils";

const Subsection9 = () => {
  const [transformedResponse, setTransformedResponse] = useState<TextResponse | null>(null);

  const { getAccessTokenSilently } = useAuth0();
  const { year, institution } = useParams();

  useEffect(() => {
    const getData = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section6/subsection9/?report_year=${year}`;
      const { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeTextResponse(data)) {
        setTransformedResponse(data);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    getData();
  }, [getAccessTokenSilently, year]);

  return (
    <>
      <h2>6.9 Your counteroffer: Why it did not materialize (Open-text Response)</h2>
      <h3>How do faculty interpret the absence of a counteroffer?</h3>

      <div className="grid">
        <div className="grid-row-title">
          <em>Prompt:</em>
        </div>
        <div>
          Why do you suspect you did not receive a counteroffer from <span className="red-variable-name">{formatRouteText(institution)}</span>?
        </div>
        <div className="grid-row-title">
          <em>Paths:</em>
        </div>
        <div>
          Departures and retentions
        </div>
      </div>
      <p>Note: This question excludes those who received counteroffers.</p>

      <h4>Departures</h4>
      {transformedResponse && transformedResponse.institution.departure &&
        <>
          {transformedResponse.institution.departure.length === 0 ? <>No text responses to display.</> :
            <ul>
              {transformedResponse.institution.departure.map((response: string, i: number) =>
                <li key={i}>{cleanString(response)}</li>
              )}
            </ul>
          }
        </>
      }
      <h4>Retentions</h4>
      {transformedResponse && transformedResponse.institution.retention &&
        <>
          {transformedResponse.institution.retention.length === 0 ? <>No text responses to display.</> :
            <ul>
              {transformedResponse.institution.retention.map((response: string, i: number) =>
                <li key={i}>{cleanString(response)}</li>
              )}
            </ul>
          }
        </>
      }
      
    </>
  )
}

export default Subsection9;